<template>
  <div class="mr15">
    <h4 class="comm_tit02">
      {{ title03 }}
    </h4>
  </div>
</template>

<script>
export default {
  name: 'SampleTab03',
  data() {
    return {
      title03: 'TAB03',
    };
  },
  mounted() {
    console.log(`>>\t${this.title03}`);
  },
  methods: {
    reset() {
      console.log('[SampleTab03] reset() was called.');
      this.title03 = '----- reset03';
      console.log(`>>\t${this.title03}`);
    },
  },
};
</script>

<style scoped>
</style>
